import React from 'react';
import Text from 'shared/components/Text/Text';
import { useTranslation } from 'react-i18next';
import { AgentScheduleContainer } from './OnboardingTPV.styles';

export function TPVAgentSchedule() {
  const { t } = useTranslation('translation', { keyPrefix: 'onboarding.tpv' });

  return (
    <AgentScheduleContainer>
      <Text as="p">{t('agentsAvailable')}</Text>
      <div>
        <div>
          <Text as="p">{t('weekdays', { monday: 1, friday: 5 })}</Text>
          <Text as="p">{t('tpvAgentHoursWeekdays')}</Text>
        </div>
        <div>
          <Text as="p">{t('sat', { saturday: 6 })}</Text>
          <Text as="p">{t('tpvAgentHoursSaturday')}</Text>
        </div>
        <div>
          <Text as="p">{t('sun', { sunday: 0 })}</Text>
          <Text as="p">{t('tpvAgentHoursSunday')}</Text>
        </div>
      </div>
    </AgentScheduleContainer>
  );
}

export default TPVAgentSchedule;
